<form [formGroup]="accessoryForm">
  <div class="form-group">
    <label>Name</label>
    <input formControlName="name"
           class="form-control"
           type="text"
           [maxlength]="REQS.maxLength.standard"
           value="{{accessory.name}}">
  </div>
  <div class="form-group">
    <label>PBS Name</label>
    <input formControlName="pbsName"
           class="form-control"
           type="text"
           [maxlength]="REQS.maxLength.standard"
           value="{{accessory.pbsName}}">
  </div>
  <div class="form-group">
    <label>PBS Type</label>
    <input formControlName="pbsType"
           class="form-control"
           type="text"
           [maxlength]="REQS.maxLength.standard"
           value="'Protection'">
  </div>
  <div class="form-group">
    <label>Tag Line</label>
    <input formControlName="tagLine"
           class="form-control"
           type="text"
           [maxlength]="REQS.maxLength.standard"
           value="{{accessory.tagLine}}">
  </div>
  <!-- <div class="form-group">
    <label>Price</label>
    <input formControlName="price"
           class="form-control"
           type="number"
           value="{{accessory.price}}">
  </div>
  <div class="form-group">
    <label>Cost</label>
    <input formControlName="cost"
           class="form-control"
           type="number"
           value="{{accessory.cost}}">
  </div> -->
  <div class="d-flex flex-row align-items-end">
  <p>Options</p>
  <a (click)="createOption()">
    <i class="material-icons text-success h2 clickable">add</i>
  </a>
</div>
  <ul formArrayName="options" class="unstyled">
  <li *ngFor="let option of optionsAsFormArray.controls; let i = index" [formGroupName]="i">
    <div class="form-group">
      <label>Name</label>
      <input formControlName="name" class="form-control" type="text" [maxlength]="REQS.maxLength.standard">
    </div>
    <div class="form-group">
      <label>Label</label>
      <input formControlName="label" class="form-control" type="text" [maxlength]="REQS.maxLength.standard">
    </div>
    <div class="form-group">
      <label>PBS Name</label>
      <input formControlName="pbsName" class="form-control" type="text">
    </div>
    <div class="form-group">
      <label>Is Default Selection?</label>
      <input formControlName="defaultSelection" class="form-control checkbox" type="checkbox">
    </div>
    <div class="form-group">
      <label>Price</label>
      <input formControlName="price" class="form-control" type="number">
    </div>
    <div class="form-group">
      <label>Cost</label>
      <input formControlName="cost" class="form-control" type="number">
    </div>

    <!-- TODO: Determine whether to include option details -->
    <!-- <div class="d-flex flex-row align-items-end">
      <p>Option Details</p>
      <a (click)="addOptionDetail(i)"><i class="material-icons text-success h2">add</i></a>
    </div>
    <ul formArrayName="details" class="unstyled">
      <li *ngFor="let d of optionDetails(i)?.controls; let j = index" class="d-flex flex-row">
        <input [formControlName]="j" class="form-control" type="text">
        <a (click)="removeOptionDetail(i, j)"><i class="material-icons text-danger h2">delete_sweep</i></a>
      </li>
    </ul> -->

    <a (click)="removeOption(i)"><i class="material-icons text-danger h2 float-right clickable">delete_sweep</i></a>
  </li>
</ul>

  
  <div>
    <div class="d-flex flex-row align-items-end">
      <p>Details</p>
      <a (click)="createDetail()">
        <i class="material-icons text-success h2 clickable">add</i>
      </a>
    </div>
    <ul formArrayName="details"
        class="unstyled">
      <li *ngFor="let detail of details; let i = index;">
        <div class="form-group">
          <div class="d-flex flex-row">
            <input formControlName="{{i}}"
                   class="form-control"
                   type="text"
                   value="{{detail}}">
            <a (click)="removeDetail(i)">
              <i class="material-icons text-danger h2 float-right clickable">delete_sweep</i>
            </a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</form>